import React from 'react';

export const StepClientInfo = ({ formData, setFormData, agences, commerciaux, onPrev, onNext, onSaveDraft }) => (
  <div className="bg-white border border-[#BFC6CC] rounded-lg p-8">
    <h2 className="text-2xl font-heading font-semibold text-[#191D1E] mb-6">
      Informations Client
    </h2>
    
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-[#191D1E] mb-2">Nom Client *</label>
          <input
            type="text"
            required
            value={formData.nom_client}
            onChange={(e) => setFormData({...formData, nom_client: e.target.value})}
            className="w-full px-4 py-3 border border-[#BFC6CC] rounded-lg focus:ring-2 focus:ring-[#397DFF]"
            placeholder="Nom de l'entreprise"
            data-testid="turpe-client-name"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-[#191D1E] mb-2">SIREN *</label>
          <input
            type="text"
            required
            value={formData.siren}
            onChange={(e) => setFormData({...formData, siren: e.target.value.replace(/\D/g, '').slice(0, 9)})}
            className="w-full px-4 py-3 border border-[#BFC6CC] rounded-lg focus:ring-2 focus:ring-[#397DFF] font-mono"
            placeholder="123456789"
            maxLength={9}
            data-testid="turpe-siren"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-[#191D1E] mb-2">Agence PDE *</label>
          <select
            required
            value={formData.agence_id}
            onChange={(e) => setFormData({...formData, agence_id: e.target.value, commercial_id: ''})}
            className="w-full px-4 py-3 border border-[#BFC6CC] rounded-lg focus:ring-2 focus:ring-[#397DFF]"
            data-testid="turpe-agence"
          >
            <option value="">Sélectionner</option>
            {agences.map(a => <option key={a.id} value={a.id}>{a.nom}</option>)}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-[#191D1E] mb-2">Commercial *</label>
          <select
            required
            disabled={!formData.agence_id}
            value={formData.commercial_id}
            onChange={(e) => setFormData({...formData, commercial_id: e.target.value})}
            className="w-full px-4 py-3 border border-[#BFC6CC] rounded-lg focus:ring-2 focus:ring-[#397DFF] disabled:bg-[#F5F6F9]"
            data-testid="turpe-commercial"
          >
            <option value="">Sélectionner</option>
            {commerciaux.filter(c => c.agence_id === formData.agence_id).map(c => (
              <option key={c.id} value={c.id}>{c.prenom} {c.nom}</option>
            ))}
          </select>
        </div>
      </div>
    </div>

    <div className="flex justify-between gap-3 pt-6">
      <button onClick={onPrev} className="px-6 py-3 border border-[#BFC6CC] text-[#687175] rounded-lg">← Retour</button>
      <div className="flex gap-3">
        <button
          onClick={onSaveDraft}
          className="flex items-center gap-2 px-4 py-2 border border-[#F9C80E] text-[#F9C80E] hover:bg-[#F9C80E] hover:text-white rounded-lg transition-colors"
        >
          Enregistrer Brouillon
        </button>
        <button onClick={onNext} className="bg-[#397DFF] text-white py-3 px-8 rounded-lg">Suivant : PDL →</button>
      </div>
    </div>
  </div>
);
